function isOnline() {
  if ('onLine' in navigator) {
    return navigator.onLine
  }
  return true
}

export default isOnline
